import { FC } from 'react';

import Image from 'next/image';

import { Container, Content } from './styles';

import { maskPhoneNumber } from '~/utils/masks';

export const NotFound: FC = () => {
  return (
    <Container>
      <Content>
        <div>
          <Image
            src="/images/logos/white-logo.png"
            width={200}
            height={110}
            alt="MenuFacil"
          />
        </div>
        <span className="big-text margin-bottom">oops...</span>
        <span className="margin-bottom">a página não foi encontrada</span>
        <span className="outline">
          Se persistir o erro, informe ao nosso time
          <br />
          {maskPhoneNumber('19999895592')}
        </span>
      </Content>
    </Container>
  );
};
